export default __webpack_public_path__ + "static/media/slider-thumb.b7b21620.svg";